import styled from '@emotion/styled';

export const CreateFormStyles = styled('div')`
    border: 1px solid #fff;
    padding: 1rem 2rem;
    .form-element {
        overflow-wrap: break-word;
        transition: all 0.25s ease-in;
        border: 1px solid #fff;
        min-height: 120px;
        border-radius: 5px;
    }
    .form-element:hover {
        border: 1px solid #50aeb0;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
    .form-element-control {
        display: none;
    }
    .form-element:hover * .form-element-control {
        display: block;
    }
`;

export const CopyFormStyled = CreateFormStyles;
export const EditFormStyles = CreateFormStyles;
